export default "__VITE_ASSET__833df6eb__"